module.exports = __webpack_public_path__ + "static/media/issue_update_icon3.4b8d4fb9.svg";